// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__jI840","topBottomGutter":"Layout_topBottomGutter__25WbS"};